import axios from './api';

const API_URL = '/membres/';

const createMembre = async (userData) => {
  const response = await axios.post(API_URL,userData);
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

const getAll = async() => {
  const response = await axios.get(API_URL);
  return response.data;
};

const deleteMembre = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const updateMembre = async (data,token) => {
  const response = await axios.patch(API_URL,data);
  return response.data;
};

const MembreService = {
  deleteMembre,
  updateMembre,
  getAll,
  getById,
  createMembre
};

export default MembreService;
